import { Theme } from "@mui/material";
import { SxObjType } from "lib/theme/types/SxObjType.type";

export const sxStyles = (theme: Theme) => {
  return {
    loadingContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      mt: 4,
    },
    headerContainer: {
      mb: 2,
    },
    footerContainer: {
      p: 2,
    },
  } satisfies SxObjType;
};
